<!-- Refund confirmation -->
<template>
  <div>
    <ItemDialog ref="DialogBookRefundConfirmation" imageType="alert">
      <template v-slot:content-area>
        <h2>払い戻し申請</h2>
        <br />
        <br />
        <span class="text-justify"
          >以下のボタンから払い戻し申請を受け付けます。払い戻し処理には少々お時間を頂きます。返金までいましばらくお待ちください。
        </span>
        <br />
        <br />
        <span class="text-warning"
          >払い戻し申請を実行するとこのチケットは利用・変更できなくなります。</span
        >
        <br />
        <span class="text-warning"
          >一度申請すると取り消しできませんのでご注意ください。</span
        >
      </template>
      <template v-slot:button-area>
        <ItemButton
          label="払い戻し申請"
          actionType="btn-primary"
          @clicked="acceptRefund"
        />

        <ItemButton
          label="キャンセル"
          actionType="btn-cancel"
          @clicked="closeDialog"
        />
      </template>
    </ItemDialog>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "DialogBookRefundConfirmation",
  props: {
    executeRefund: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const DialogBookRefundConfirmation = ref(null);
    const openDialog = () => {
      DialogBookRefundConfirmation.value.open();
    };

    const closeDialog = () => {
      DialogBookRefundConfirmation.value.close();
    };

    const acceptRefund = () => {
      DialogBookRefundConfirmation.value.close();
      if (props.executeRefund != null) {
        props.executeRefund();
      }
    };

    return {
      DialogBookRefundConfirmation,
      openDialog,
      closeDialog,
      acceptRefund,
    };
  },
};
</script>

<style scoped lang="scss">
.text-justify {
  text-align: justify;
  font-size: 16px;
}
.text-warning {
  color: #ff0000;
  font-size: 16px;
}
</style>